package com.fireavert.events.shared.data_models.models

enum class EventType {
    DeviceTriggered,
    SmokeAlarmActive,
    AutoRebootTimeout,
    DeviceReset,
    DeviceOffline,
    DeviceConnected,
    StoveOnTooLong,
    Unknown
}